import React from 'react';

import { useIntl } from 'react-intl';

import styles from './CouponApply.module.scss';
import messages from './messages';

const CouponApplyFailure = ({ goToRecommendedCoupons, error }) => {
  const intl = useIntl();
  const errorString = error && typeof error === 'string' ? error : intl.formatMessage(messages.checkOutOthersMessage);

  return (
    <div className={styles.card}>
      <div className={styles.icon}>
        <span role="img" aria-label="" style={{ fontSize: '3rem' }}>
          🔔
        </span>
      </div>
      <h1 className={styles.title}>{intl.formatMessage(messages.requestFailedTitle)}</h1>
      <p className={styles.description}>{errorString}</p>
      <p className={styles.description}>{intl.formatMessage(messages.checkOutOthersMessage)}</p>
      <button type="button" className={styles.actionBtn} onClick={goToRecommendedCoupons}>
        {intl.formatMessage(messages.continueBrowsingText)}
      </button>
    </div>
  );
};

export default CouponApplyFailure;